import {
    siteIdsFailure,
    siteIdsLoading,
    siteIdsSuccess,
    categoriesFailure,
    categoriesLoading,
    categoriesSuccess,
    adminSitesFailure,
    adminSitesLoading,
    adminSitesSuccess,
} from 'redux/actions/site';
import * as requests from 'api/requests';
import { displayErrorSwal } from 'utilities/Validations';

export function getSiteIds() {
    return (dispatch) => {
        dispatch(siteIdsLoading());

        return requests
            .getSiteIds()
            .then((data) => {
                dispatch(siteIdsSuccess(data));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred getting sites, please try again later.')
                dispatch(siteIdsFailure(error));
            });
    };
}

export function getCategories() {
    return (dispatch) => {
        dispatch(categoriesLoading());

        return requests
            .getCategories()
            .then((data) => {
                dispatch(categoriesSuccess(data));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred getting categories, please try again later.')
                dispatch(categoriesFailure(error));
            });
    };
}

export function getAdminSiteIds() {
    return (dispatch) => {
        dispatch(adminSitesLoading());

        return requests
            .getAdminSiteIds()
            .then((data) => {
                dispatch(adminSitesSuccess(data));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred getting admin sites, please try again later.')
                dispatch(adminSitesFailure(error));
            });
    };
}
